<div class="spinner--container">
	<div class="spinner--content-{{direction}}">
		<div class="spinner--{{size}}"></div>
		<p *ngIf="message" class="spinner--text-{{messageSize}} spinner--text-color-{{messageColor}}">{{message}}</p>
	</div>
</div>
